import getSymbolFromCurrency from "currency-symbol-map";


type TSuffix = "" | "K" | "M" | "B" | "T";
type TFormatNumber = {
    number: number | string | undefined | null
    currency: string | undefined | null
}

export const formatCurrency = ({ number, currency }: TFormatNumber): string => {
    if (number === undefined || number === null || isNaN(+number)) return `${currency && getSymbolFromCurrency(currency)}`;
    if (+number < 1000) return `${number.toString()}${currency && getSymbolFromCurrency(currency)}`;
    const suffixes: TSuffix[] = ["", "K", "M", "B", "T"];
    const tier = Math.floor(Math.log10(+number) / 3);
    const suffix = suffixes[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = +number / scale;
    // const truncated = Math.trunc(scaled * 100) / 100;
    const formatted =
        scaled % 1 === 0 ? scaled.toFixed(0) : scaled.toFixed(1);
    // const formatted = truncated.toFixed(2);
    // const noDot00 = formatted.replace(/\.00$/, "");

    return `${formatted}${suffix}${currency && getSymbolFromCurrency(currency)}`;
}